import React from "react";

import { Heading1 } from "../../styles/typography";

type FallbackScreenProps = {
  headingText: React.ReactNode;
  description: React.ReactNode;
  actionButtons: Array<React.ReactNode>;
  svgImage: React.ReactNode;
};

export function FallbackScreen({
  headingText,
  description,
  actionButtons,
  svgImage,
}: FallbackScreenProps) {
  return (
    <div className="flex flex-col items-center pt-10 pb-12 max-w-5xl mx-auto">
      <Heading1 italic className="text-center">
        {headingText}
      </Heading1>
      <div className="pt-6 pb-12 text-center">{description}</div>
      <div className="space-x-6 pb-6">{actionButtons}</div>
      <div className="p-8">{svgImage}</div>
    </div>
  );
}
